import { $api } from "../AxiosInstance";

export class DiscountService {
  // Count Discounts
  static async getCountDiscount() {
    return await $api.get("/api/admin/discountForNumberOfProxies/all");
  }

  static async getCountDiscountIPv6() {
    return await $api.get("/api/admin/discountForNumberOfProxiesIPv6/all");
  }

  static async getCountDiscountMobile() {
    return await $api.get("/api/admin/discountForNumberOfProxiesMobile/all");
  }

  static async getCountDiscountISP() {
    return await $api.get("/api/admin/discountForNumberOfProxiesISP/all");
  }

  static async getCountDiscountById(id, typeProxy) {
    return await $api.get(`/api/admin/discountForNumberOfProxies${typeProxy}`, {
      params: { id },
    });
  }

  static async createCountDiscount(count, discount, typeProxy) {
    return await $api.put(`/api/admin/discountForNumberOfProxies${typeProxy}`, {
      count,
      discount,
    });
  }

  static async saveCountDiscount(id, count, discount, typeProxy) {
    return await $api.post(`/api/admin/discountForNumberOfProxies${typeProxy}`, {
      id,
      count,
      discount,
    });
  }

  static async deleteCountDiscount(id, typeProxy) {
    return await $api.delete(`/api/admin/discountForNumberOfProxies${typeProxy}`, {
      params: { id },
    });
  }

  // Days Discounts
  static async getDaysDiscount() {
    return await $api.get("/api/admin/discountForNumberOfDays/all");
  }

  static async getDaysDiscountIPv6() {
    return await $api.get("/api/admin/discountForNumberOfDaysIPv6/all");
  }

  static async getDaysDiscountISP() {
    return await $api.get("/api/admin/discountForNumberOfDaysISP/all");
  }

  static async getDaysDiscountMobile() {
    return await $api.get("/api/admin/discountForNumberOfDaysMobile/all");
  }

  static async getDaysDiscountById(id, typeProxy) {
    return await $api.get(`/api/admin/discountForNumberOfDays${typeProxy}`, {
      params: { id },
    });
  }

  static async createDaysDiscount(days, discount, typeProxy) {
    return await $api.put(`/api/admin/discountForNumberOfDays${typeProxy}`, {
      days,
      discount,
    });
  }

  static async saveDaysDiscount(id, days, discount, typeProxy) {
    return await $api.post(`/api/admin/discountForNumberOfDays${typeProxy}`, {
      id,
      days,
      discount,
    });
  }

  static async deleteDaysDiscount(id, typeProxy) {
    return await $api.delete(`/api/admin/discountForNumberOfDays${typeProxy}`, {
      params: { id },
    });
  }
}
